import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

// Selectors:
import { touristsSkipDocSelector } from 'src/store/tourists/selectors';
import {
  getInsuranceOption,
  getIsSelectedInsurance,
} from '../../store/domains/package-upsale-options/selectors';
import { toggleInsurance } from '../../store/domains/package-upsale-options/slice';
import { ExtraInsurance } from './ExtraInsurance';

const mapStateToProps = (state) => ({
  insurance: getInsuranceOption(state),
  isTouristsSkipDoc: touristsSkipDocSelector(state),
  isSelectedInsurance: getIsSelectedInsurance(state),
});

const mapDispatchToProps = {
  toggleInsurance,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PropsFromRedux = ConnectedProps<typeof connector>;
export default connector(ExtraInsurance);
